import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, Input, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AppMenu } from 'app/back-office/shared/models/core/app-menu.model';
import { CoreMenuService } from 'app/back-office/layout/core-menu/core-menu.service';
import { CoreMenuVerticalItemComponent } from 'app/back-office/layout/core-menu/vertical/item/item.component';
import { CoreMenuVerticalSectionComponent } from 'app/back-office/layout/core-menu/vertical/section/section.component';
import { CoreMenuVerticalCollapsibleComponent } from 'app/back-office/layout/core-menu/vertical/collapsible/collapsible.component';
import { CoreMenuHorizontalItemComponent } from 'app/back-office/layout/core-menu/horizontal/item/item.component';
import { CoreMenuHorizontalCollapsibleComponent } from 'app/back-office/layout/core-menu/horizontal/collapsible/collapsible.component';

@Component({
    selector: '[core-menu]',
    imports: [
        NgClass,
        RouterModule,
        CoreMenuVerticalItemComponent,
        CoreMenuVerticalSectionComponent,
        CoreMenuVerticalCollapsibleComponent,
        CoreMenuHorizontalItemComponent,
        CoreMenuHorizontalCollapsibleComponent
    ],
    templateUrl: './core-menu.component.html',
    styleUrls: ['./core-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoreMenuComponent implements OnInit {
  @Input()
  layout = 'vertical';

  // Resta @Input decorator: viene riassegnato internamente dal servizio,
  // quindi non è convertibile a input() signal (read-only)
  @Input()
  menu: AppMenu;

  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _coreMenuService = inject(CoreMenuService);
  private _destroyRef = inject(DestroyRef);

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Set the menu either from the input or from the service
    this.menu = this.menu || this._coreMenuService.getCurrentMenu();

    // Subscribe to the current menu changes
    this._coreMenuService.onMenuChanged.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      // Load menu
      this.menu = this._coreMenuService.getCurrentMenu();

      this._changeDetectorRef.markForCheck();
    });
  }
}
